module.exports = __webpack_public_path__ + "img/Health & Medical.72e20838.png";